import { render, staticRenderFns } from "./BaseTourGuideLink.vue?vue&type=template&id=b210c276&scoped=true&"
import script from "./BaseTourGuideLink.vue?vue&type=script&lang=js&"
export * from "./BaseTourGuideLink.vue?vue&type=script&lang=js&"
import style0 from "./BaseTourGuideLink.vue?vue&type=style&index=0&id=b210c276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210c276",
  null
  
)

export default component.exports